import {
  Component, OnInit, ElementRef, forwardRef, Input, OnChanges, Output, EventEmitter,
  Renderer2, OnDestroy, Self, Query, QueryList, Directive, Provider, ViewEncapsulation, NgModule, SimpleChanges
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ControlValueAccessor, SelectControlValueAccessor } from '@angular/forms';
import { CustomCodeValuesController, CustomCodeTypeRequest } from './customdatabyrequesttype.interface';
import { CUstomDataByRequestTypeService } from './customdatabyrequesttype.service';
import { Router } from '@angular/router';
import { AppData } from '../../models/appdata';
import { ApiResponseModel } from '../../models/api_response_model';

const noop = () => {
};

export const CUSTUM_CodeTypeList_Value_ACCESSOR: any =
  {
    provider: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomDataByRequestTypeListComponent),
    multi: true
  };

@Component({
  selector: 'CustomDataByRequestTypeList',

  templateUrl: './CustomDataByRequestTypeList.componenet.html',
  providers: [CUstomDataByRequestTypeService
    //, CUSTUM_CodeTypeList_Value_ACCESSOR
    ,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDataByRequestTypeListComponent),
      multi: true
    }

  ],
})
export class CustomDataByRequestTypeListComponent implements OnInit, OnChanges
  , ControlValueAccessor
{
  ngOnChanges(changes: SimpleChanges) {
    let shouldRefresh = false;
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        const change = changes[propName];
        if (!change.firstChange && change.currentValue !== change.previousValue) {
          shouldRefresh = true;
        }
      }
    }
    if (shouldRefresh) {
      this.refreshAndLoadData();
    }
  }

  refreshAndLoadData() {
    if (!this.CurrentCustomCodeTypeRequest) {
      this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
    }
    this.CurrentCustomCodeTypeRequest.RequestedType = this.RequestedType;
    this.CurrentCustomCodeTypeRequest.FacilityCode = Number(this.FacilityCode) || 0;
    this.CurrentCustomCodeTypeRequest.ActorCode = Number(this.ActorCode) || 6;
    this.CurrentCustomCodeTypeRequest.CustomCode = Number(this.CustomCode) || 0;
    this.CurrentCustomCodeTypeRequest.CustomType = this.CustomType || "0";
    this.CurrentCustomCodeTypeRequest.StringContains = this.StringContains || "0";
    const apiModel = AppData.Instance().ApiRequestParms || { xUserName: 'admin', xAuthGenKEY: '' } as any;
    this.CurrentCustomCodeTypeRequest.SendApiRequestModel = apiModel;
    if (!this.CurrentCustomCodeTypeRequest.SendApiRequestModel.xUserName) {
      this.CurrentCustomCodeTypeRequest.SendApiRequestModel.xUserName = 'admin';
    }
    this.RequestedTypeValueByType();
  }
 
  //http://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel
  // ------------------------------------

  private innerValue: any = '';
  public isRequesting: boolean = false;
  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  RequestedTypeValueArray: Array<string>;
  public SelectedListValue: string;

  public key: string;

  @Input()
  get Key() {
    return this.key;
  }

  @Output() keyChange = new EventEmitter();
  set Key(value: string) {
    this.key = value;
    //  alert(this.Key);       
    this.keyChange.emit(this.key);
  }


  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }



  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
  //------------------------------------------


  //registerOnTouched(fn: any) {
  //    this.onTouchedCallback = fn;

  //}
  onChange(Event: any) {
    //alert("hi");
    console.log("----Event----------------" + Event)
    if (Event != null) {

      var a = this.CurrentCustomCodeValuesController.filter(x => x.Code === parseInt(Event))
      if (a.length > 0) {
        this.Key = a[0].DisplayName;
        //console.log('this.Key-->' + this.Key + ' a[0].Code->' + a[0].DisplayName);

      }
      else {
        this.key = "";
      }
    }
    this.innerValue = Event;
    this.onTouchedCallback();
    this.onChangeCallback(this.innerValue);
    console.log(this.innerValue);

  }

  //***********************************/

  //@Input() IsSelected: boolean =false;
  @Input() SelectedValue: string = "";
  @Input() public DisplayLabelText: string = "";
  @Input() public DisplayDefaultValue: string = "";

  //
  @Input() RequestedType: string;
  @Input() public FacilityCode: number = 0;
  @Input() public ActorCode: number = 0;
  @Input() public CustomCode: number = 0;
  @Input() public CustomType: string = "0";
  @Input() public StringContains: string = "0";

  public ApiResData: ApiResponseModel;

  CurrentCustomCodeTypeRequest: CustomCodeTypeRequest;
  CurrentCustomCodeValuesController: CustomCodeValuesController[];

  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    public _router: Router, public CustomDataByRequestTypeListService: CUstomDataByRequestTypeService) {
  }

  ngOnInit() {
    this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
    this.CurrentCustomCodeTypeRequest.RequestedType = this.RequestedType;
    this.CurrentCustomCodeTypeRequest.FacilityCode = this.FacilityCode;
    this.CurrentCustomCodeTypeRequest.ActorCode = this.ActorCode;
    this.CurrentCustomCodeTypeRequest.CustomCode = this.CustomCode;
    this.CurrentCustomCodeTypeRequest.CustomType = this.CustomType;
    this.CurrentCustomCodeTypeRequest.StringContains = this.StringContains;
    this.CurrentCustomCodeTypeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
   

    this.CurrentCustomCodeValuesController = new Array<CustomCodeValuesController>();

    if (this.DisplayDefaultValue != "" && this.DisplayDefaultValue != null) {
      this.SelectedListValue = this.DisplayDefaultValue;
      //alert(result);
      this.innerValue = this.DisplayDefaultValue;
      this.onTouchedCallback();
      this.onChangeCallback(this.innerValue);
      console.log(this.innerValue);
    }

    this.RequestedTypeValueByType();

  }



  RequestedTypeValueByType(): void {
    this.StartRefreshing();

    this.CustomDataByRequestTypeListService.GetCustomDataByRequestedType(this.CurrentCustomCodeTypeRequest).subscribe
      (
    
       (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCustomCodeValuesController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            alert(' Failed Due to Internal Error.... Please Contact Admin..');
          }
        }

      },
      (error) => {

        if (error == "401 - Unauthorized") {
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
        }
      }
      //
      );;

  }
  private stopRefreshing() {
    this.isRequesting = false;

  }
  private StartRefreshing() {
    this.isRequesting = true;

  }



}
